
  document.addEventListener('DOMContentLoaded', function() {
    // Check if mobile
    function isMobile() {
        return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    // Smooth scroll to gallery
    function scrollToGallery() {
        if (!isMobile()) return;
        
        // Target: top of page or specific gallery element
        const gallery = document.querySelector('.product__media') || 
                       document.querySelector('.product-media-container') ||
                       document.querySelector('[data-testid="product-media"]') ||
                       document.querySelector('.swiper-container');
        
        const scrollTarget = gallery ? gallery.offsetTop - 80 : 0; // 80px offset for header
        
        window.scrollTo({
            top: scrollTarget,
            behavior: 'smooth'
        });
    }

    // Listen to variant select changes
    const variantSelects = document.querySelectorAll('.variant-option__select, [name^="options"]');
    
    variantSelects.forEach(select => {
        select.addEventListener('change', function() {
            // Small delay to ensure DOM updates
            setTimeout(scrollToGallery, 100);
        });
    });

    // Alternative: Listen to custom Shopify variant change event
    document.addEventListener('variant:change', scrollToGallery);
    
    // For variant picker component with buttons instead of select
    const variantButtons = document.querySelectorAll('.variant-option__button, .variant-picker__option');
    
    variantButtons.forEach(button => {
        button.addEventListener('click', function() {
            setTimeout(scrollToGallery, 100);
        });
    });

    // Mutation observer for dynamic variant pickers
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && 
                (mutation.attributeName === 'class' || mutation.attributeName === 'aria-checked')) {
                const target = mutation.target;
                
                // Check if it's a variant-related element
                if (target.closest('.variant-picker') || target.closest('.variant-option')) {
                    if (isMobile() && target.classList.contains('selected') || 
                        target.getAttribute('aria-checked') === 'true') {
                        scrollToGallery();
                    }
                }
            }
        });
    });

    // Start observing variant picker for changes
    const variantPicker = document.querySelector('.variant-picker, variant-picker');
    if (variantPicker) {
        observer.observe(variantPicker, {
            attributes: true,
            childList: true,
            subtree: true
        });
    }
});

// Alternative implementation using Web Components if variant-picker is a custom element
if (customElements.get('variant-picker')) {
    const originalConnectedCallback = customElements.get('variant-picker').prototype.connectedCallback;
    
    customElements.get('variant-picker').prototype.connectedCallback = function() {
        if (originalConnectedCallback) {
            originalConnectedCallback.call(this);
        }
        
        this.addEventListener('change', function() {
            if (window.innerWidth <= 768) {
                setTimeout(() => {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }, 150);
            }
        });
    };
}